"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function makeReservedSpace(props) {
    var reserveSpace = props.reserveSpace, error = props.error, helperText = props.helperText;
    var hasSpace;
    var propKeys = Object.keys(props);
    if (typeof reserveSpace === 'boolean') {
        hasSpace = reserveSpace;
        if (error || helperText) {
            hasSpace = true;
        }
    }
    else {
        hasSpace = propKeys.includes('error') || propKeys.includes('helperText');
    }
    return hasSpace;
}
exports.default = makeReservedSpace;
